<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<form (ngSubmit)="onSubmit(inputForm)" #inputForm="ngForm">
  <h5 class="mb-2">{{ 'user-self-service.security.tan-enrollment.headline' | transloco }}</h5>

  @if (!authorizationMode && !enrollmentCredential) {
    <p class="mb-4">{{ 'user-self-service.security.tan-enrollment.info-text' | transloco }}</p>
    <div class="input-group-material" [class.input-group-material--error]="!deviceNameInputVar.value && deviceNameInputVar.touched">
      <input
        type="text"
        required
        [(ngModel)]="customerDeviceName"
        name="deviceNameInput"
        id="deviceNameInput"
        pattern="^[0-9a-zA-Z _\-äöüÄÖÜß]+$"
        #deviceNameInputVar="ngModel"
        [zeroForbiddenNames]="deviceNameList"
        [class.empty]="!deviceNameInputVar.value"
        autocomplete="off"
        maxlength="50"
      />
      <div class="input-group-material-icon-state"></div>
      <label for="deviceNameInput"
        >{{ 'user-self-service.security.tan-enrollment.device-name' | transloco
        }}<span class="label-required">&nbsp;({{ 'user-self-service.security.tan-enrollment.required' | transloco }})</span></label
      >
      @if (!deviceNameInputVar.value && deviceNameInputVar.touched) {
        <div class="input-group-material-message">{{ 'user-self-service.security.tan-enrollment.error-no-name' | transloco }}</div>
      }
      @if (deviceNameInputVar.hasError('pattern')) {
        <div class="input-group-material-message">
          {{ 'user-self-service.security.tan-enrollment.error-pattern' | transloco }}
        </div>
      }
      @if (deviceNameInputVar.hasError('forbiddenName')) {
        <div class="input-group-material-message">{{ 'user-self-service.security.tan-enrollment.error-used-name' | transloco }}</div>
      }
    </div>
    <div class="row mt-4">
      <div class="col col-md-6 d-flex align-items-center">
        <web-design-system-button [disabled]="!inputForm.valid" size="small" class="mr-4" [isSubmit]="true">{{
          'user-self-service.security.tan-enrollment.accept' | transloco
        }}</web-design-system-button>
        <a class="link link-secondary font-size-smaller1" href="javascript:void(0)" (click)="cancelEnrollment()">{{
          'user-self-service.security.tan-enrollment.cancel' | transloco
        }}</a>
      </div>
    </div>
  }
  @if (authorizationMode && !enrollmentCredential) {
    <p>
      {{ 'user-self-service.security.tan-enrollment.authorize-text' | transloco }}
      <strong>{{ customerDeviceName }}</strong>
    </p>
    <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
  }
  @if (enrollmentCredential && !newDeviceFound) {
    <div class="row">
      <div class="col">
        <p>{{ 'user-self-service.security.tan-enrollment.qr-code-text' | transloco }}</p>
        <p class="mb-0">{{ enrollmentCredential }}</p>
        <p>
          <img alt="QR Code zum Einscannen" [src]="'data:image/png;base64,' + imgData" />
        </p>
        <p class="mt-3 text-color-primary">{{ 'user-self-service.security.tan-enrollment.waiting' | transloco }}</p>
      </div>
    </div>
  }
  @if (newDeviceFound) {
    <div class="row">
      <div class="col">
        <p>{{ 'user-self-service.security.tan-enrollment.success-text' | transloco }}</p>
        <web-design-system-button size="small" (click)="finishEnrollment()">{{
          'user-self-service.security.tan-enrollment.ok' | transloco
        }}</web-design-system-button>
      </div>
    </div>
  }
</form>
